import axios from "axios"
import {ExamRun} from "../types"

export const loadExamRuns = async (authHeader: object): Promise<ExamRun[]> => {
    const response = await axios.get<ExamRun[]>("/api/eexam/runs", authHeader)
    return response.data
}

export const saveExamRun = async (data: Partial<ExamRun>, authHeader: object): Promise<ExamRun> => {
    if (data._id) {
        const response = await axios.put<ExamRun>(`/api/eexam/runs/${data._id}`, data, authHeader)
        return response.data
    }

    const response = await axios.post<ExamRun>("/api/eexam/runs", data, authHeader)
    return response.data
}

export const deleteExamRun = async (id: string, authHeader: object): Promise<void> => {
    await axios.delete(`/api/eexam/runs/${id}`, authHeader)
}
